import { createAsyncState } from 'async-utils';
import { Nullable } from 'common-types';
import { createStore } from 'store-utils';
import { PipelineSummary } from '../pipeline-summary-types';

export const initialPipelineSummaryValues = {
  searchValue: '',
  loading: createAsyncState(),
  pipelineSummaries: null,
  total: 0,
  offset: 0,
  filtersOpen: true,
};

const PipelineSummaryStore = createStore<PipelineSummaryState>(
  initialPipelineSummaryValues,
  'Pipeline Summary Store',
);

export interface PipelineSummaryState {
  loading: ReturnType<typeof createAsyncState>;
  pipelineSummaries: Nullable<PipelineSummary[]>;
  total: number;
  offset: number;
  filtersOpen: boolean;
}

export default PipelineSummaryStore;
